import React, { useEffect } from 'react';
const GaugeChart = require('gauge-chart')

interface SpeedometerProps {
  id: string
  data: any
  testo: any
}

const Speedometer: React.FC<SpeedometerProps> = ({
    id,
    data,
    testo
}) => {
  let text = 'NaN';
  useEffect(() => {
  let ValoreAgo = data?.inuso;

const element = document.querySelector('#gaugeArea'+id)
if (element) {
  element.innerHTML = '';

const gaugeOptions = {
  hasNeedle: true,
  needleColor: 'black',
  needleUpdateSpeed: 1000,
  arcColors: ['lightgray','rgb(239,214,19)','rgb(255,84,84)'],
  arcDelimiters: [50,80],
  needleStartValue: 10,
  rangeLabel: ['0%','100%'],
}
GaugeChart.gaugeChart(element, 300, gaugeOptions).updateNeedle(ValoreAgo)
  if(id ==='PlexMount'){
    const textEl = document.querySelector('#gaugeArea' + id + ' svg text:nth-of-type(3)') as SVGTextElement;
    if (textEl) {
      const initialx = parseFloat(textEl.getAttribute('x') || '0');
      const finalx = initialx + 2.5*initialx ;
      textEl.setAttribute('x', finalx.toString());
    }
  }
  else if(id ==='Root'){
    const textEl = document.querySelector('#gaugeArea' + id + ' svg text:nth-of-type(3)') as SVGTextElement;
    if (textEl) {
      const initialx = parseFloat(textEl.getAttribute('x') || '0');
      const finalx = initialx + initialx/1.8 ;
      textEl.setAttribute('x', finalx.toString());
    }
  } 
  else{
    const textEl = document.querySelector('#gaugeArea' + id + ' svg text:nth-of-type(3)') as SVGTextElement;
    if (textEl) {
      const initialx = parseFloat(textEl.getAttribute('x') || '0');
      const finalx = initialx + initialx/2.5 ;
      textEl.setAttribute('x', finalx.toString());
    }
  }
}

  }, [data,text,id]);

  return <div className='ReturnHolder'>
          <div id={'gaugeArea'+id}></div>
          <p className="gaugeText">{"In Use: "+ data?.inuso+'%'}</p>
          <p className="gaugeText">{"Free : "+data?.libera}</p>
          <p className="gaugeText">{"Total: "+data?.totale}</p>
        </div> 
};

export default Speedometer;
